import { useMemo } from 'react';
import { useEditorStore } from '~/shell/Store';

export const useConversationBotId = (
  id: string,
  fallbackConversationBotId?: number | string
) => {
  const { sequence } = useEditorStore();

  const conversationBotId = useMemo(() => {
    type ChatBotItem = {
      __typename?: string;
      typename?: string;
      id?: string | number;
      conversationBotId?: string | number;
    };
    const currentItem = sequence?.items?.find(
      item =>
        ((item as ChatBotItem).__typename === 'ChatBot' ||
          (item as ChatBotItem).typename === 'ChatBot') &&
        (item as ChatBotItem).id === id
    ) as ChatBotItem | undefined;

    return currentItem?.conversationBotId ?? fallbackConversationBotId;
  }, [sequence?.items, id, fallbackConversationBotId]);

  const hasCreatedBots = useMemo(
    () => conversationBotId !== undefined && conversationBotId !== null,
    [conversationBotId]
  );

  return {
    conversationBotId,
    hasCreatedBots
  };
};
